export const initUtilities = () => {
	initTextClamp();
};

const initTextClamp = () => {
	const clampLines = document.querySelectorAll("[class*='clamp-lines-']");
	if (clampLines.length === 0) return;

	clampLines.forEach((elem) => {
		// only creating the title attribute if it wasn't explicitly set
		if (!elem.hasAttribute("title")) {
			elem.setAttribute("title", elem.textContent);
		}

		// console.log("clampling lines for ", elem);
		const clampClass = Array.from(elem.classList).find((cls) => cls.startsWith("clamp-lines-"));
		const lineCount = clampClass.split("-")[2];
		const lineHeight = parseFloat(getComputedStyle(elem).lineHeight);

		elem.style.maxHeight = `${lineHeight * lineCount}px`;

		if (elem.scrollHeight <= elem.maxHeight) return; // dont need to add anything else like the ellispis because it fits in the container

		let originalText = elem.textContent;
		// wait for a little while for the content to re-adjust to trim the height
		setTimeout(() => {
			while (elem.scrollHeight > parseFloat(elem.style.maxHeight) && originalText.length > 0) {
				originalText = originalText.slice(0, -1);
				elem.textContent = `${originalText}...`;
			}
		}, 3000);
	});
};
